module.exports = __webpack_public_path__ + "img/search-salon-massage-2020.785dfb66.jpg";